module.exports = __webpack_public_path__ + "static/img/img-ptfw1x.c59d046.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-ptfw1x.png
// module id = V5Id
// module chunks = 0